export enum MailCallbackType {
    CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION",
    SALES_ORDER_PAYMENT = "SALES_ORDER_PAYMENT"
}

export interface MailCallbackRequestForUserPrompt {
    callbackType: MailCallbackType;
    params: any;
    validationResults: any;
}

export interface SalesOrderPaymentCallbackParams {
    totalAmount: number;
    taxAmount?: number;
    subtotal?: number;
    currency: string;
    customerName: string;
    customerEmail?: string;
    customerAddress?: string;
    customerTin?: string;
    createdAt: string;
    items: Array<{
        title: string;
        priceCents: number;
        subscriberPriceCents?: number;
        appliedPriceCents?: number;
    }>;
    subscriberDiscountApplied: boolean;
    status?: "ALREADY_PAID";
}

export interface SalesOrderPaymentValidationResults {
    isPaid: boolean;
    priceIsActual?: boolean;
    actualTotalAmount?: number;
    actualTaxAmount?: number;
    actualSubtotal?: number;
    actualItems?: Array<{
        title: string;
        priceCents: number;
        isDiscounted: boolean;
    }>;
    actualDiscountApplied?: boolean;
    payPalOrderLink?: string;
}

export interface MailCallbackCallResponse {
    params: Record<string, any>;
}

export interface MailCallbackUserPrompt {
    params: Record<string, any>;
}
